export const plaqueData = [
  { name: 'Default', color: 'fff', image: '/img/plaque/default.jpg' },
  { name: 'Blue', color: '1515f1', image: '/img/plaque/blue.jpg' },
  { name: 'Pink', color: 'e2a3ae', image: '/img/plaque/pink.jpg' },
  { name: 'Red', color: 'ec3232', image: '/img/plaque/red.jpg' },
  { name: 'White/Black', color: 'ffffff', image: '/img/plaque/black.jpg' },
  { name: 'Yellow', color: 'f1ea24', image: '/img/plaque/yellow.jpg' },
];
